export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#96dcb8ee-54ba-4afd-ba88-a745dcd58865",
        children: [
          {
            type: "tabset",
            id: "#1261f01b-ac4d-4b08-a817-b025d6d5c313",
            weight: 7.142857142857143,
            enableMaximize: false,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-852a-62daxxx41b5881cc",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "row",
            id: "#d89e0622-b83a-4395-96df-8cd484936a06",
            weight: 92.85714285714286,
            children: [
              {
                type: "tabset",
                id: "#60a1abce-2727-4231-bc97-8c1430e906ae",
                weight: 13.128715617418012,
                enableMaximize: false,
                tabStripHeight: 6,
                children: [
                  {
                    type: "tab",
                    id: "#d7203016-ec93-4600-852a-62axxx41b5881cc",
                    name: "",
                    component: "BreakageAndReturnTableView",
                    enableClose: false,
                    enableFloat: false,
                  },
                ],
              },
              {
                type: "tabset",
                id: "#e6f0fd1d-fca3-49a5-8e85-b5669d572333",
                weight: 1.031470410826892,
                enableMaximize: false,
                children: [
                  {
                    type: "tab",
                    id: "#d7203016-ec93-4600-852addd-62xad41b5881ccx",
                    component: "ModelDate",
                    enableClose: false,
                    enableFloat: false,
                  },
                ],
                active: true,
              },
              {
                type: "row",
                id: "#c31b20f1-cbe1-467f-a96b-2552338f9b97",
                weight: 0.7615332587363914,
                children: [
                  {
                    type: "tabset",
                    id: "#b382b7a6-3299-4262-a78c-62f4e4822aa1",
                    weight: 3.268308047819583,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852addd-62ad4dd1b5881ccx",
                        component: " Pctile ",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#37ea077e-0d0b-40d5-a26e-2b846033ffa6",
                    weight: 4.404468359619933,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852axddd-62ad41b5e881ccx",
                        component: "Horizon",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#fd18d01c-5117-4edd-b932-8f2507a357b4",
                    weight: 14.781662752360837,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852axddd-62ad41b5881ccx",
                        component: "Ticker",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
